module.exports = __webpack_public_path__ + "img/5237.dc36f987.jpg";